import React, { useEffect, useState } from "react";
import { API } from "../../service/axiosInstance";
import { FaEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { toast } from "react-toastify";
import CategoryModal from "./CategoryModal";
import "./category.css";

const CategoryManager = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [nodata, setNoData] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [categoryModalData, setCategoryModalData] = useState({ status: false, data: null });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setError(null);
      setNoData(false);
      setLoading(true);
      const response = await API.getAllCategories({});
      if (response) {
        if (response.isSuccess) {
          setLoading(false);
          if (response.data.length > 0) {
            setAllCategories(response.data);
          } else {
            setNoData(true);
          }
        }
      } else {
        setLoading(false);
        setError("Something went wrong!");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setLoading(false);
      if (error.originalMessage) {
        setError(error.originalMessage);
      } else {
        setError(error.message.message);
      }
    }
  };
  const parseDate = (date) => {
    const dateObject = new Date(date);
    const formattedDate = dateObject.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
    return formattedDate;
  };
  const editCategory = (category) => {
    setCategoryModalData({ status: true, usedFor: "editCategory", data: category });
  };
  const deleteCategoryTempById = async (category) => {
    try {
      if (window.confirm("Are you sure you want to delete this category?") === true) {
        const response = await toast.promise(API.updateCategory({ ...category, activeStatus: false }, true), {
          pending: "Deleting category...",
          success: "Category Deleted👌",
          error: "Error deleting Category!🤯",
        });
        if (response.isSuccess) {
          const updatedCategoryData = JSON.parse(response.data);

          setAllCategories((prevCategories) => prevCategories.filter((singlecategory) => singlecategory._id !== updatedCategoryData._id));

          console.log("deleted documents", JSON.parse(response.data));
        }
        console.log("deleting categories", response);
      } else {
      }
    } catch (error) {}
  };
  return (
    <div className="container-fluid p-4">
      <button
        className="btn btn-primary mb-4"
        onClick={() => {
          setCategoryModalData({
            status: true,
            usedFor: "createCategory",
            data: { categoryName: "", categoryId: "", categoryDesc: "", isTrending: false },
          });
        }}
      >
        Create new Category
      </button>
      <div className="table-responsive">

     
      <table className="table table-light table-bordered table-hover table-striped">
        {allCategories.length > 0 && (
          <>
            <thead className="catHeader">
              <tr>
                <th className="text-truncate p-3 position-relative"> Category Name</th>
                <th className="text-truncate p-3 position-relative"> Trending Status</th>
                <th className="text-truncate p-3 position-relative"> Created Date</th>
                <th className="text-truncate p-3 position-relative"> Description</th>
              </tr>
             
            </thead>
            <tbody>
            {allCategories.map((category, index) => (
              <tr className="position-relative" key={index}>
                <td className="position-relative">{category.categoryName}</td>
                <td className="position-relative">{category.isTrending ? "Trending" : "Not trending"}</td>
                <td className="position-relative">{parseDate(category.createdAt)}</td>
                <td className="position-relative">
                  <span className="position-relative">{category.categoryDesc ? category.categoryDesc : "No description"}</span>
                  <div className="iconBtn align-itmes-center gap-1">
                    <button
                      className="iconbutton "
                      onClick={() => {
                        editCategory(category);
                      }}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="iconbutton "
                      onClick={() => {
                        deleteCategoryTempById(category);
                      }}
                    >
                      <MdOutlineDelete />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </>
        )}
      </table>
      </div>
      {loading && <>Loading...</>}
      {nodata && !loading && <small className="text-secondary">-- No data found --</small>}
      {error && !loading && <small className="text-danger">{error}</small>}

      <CategoryModal categoryModalData={categoryModalData} setCategoryModalData={setCategoryModalData} setAllCategories={setAllCategories} />
    </div>
  );
};

export default CategoryManager;
